function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M242.5,484.6c-61.9,0-124-23.6-171.1-70.8C25.7,368,0.5,307.3,0.5,242.5S25.7,116.9,71.4,71.4 c94.5-94.3,248-94.3,342.4,0l0,0c94.3,94.6,94.3,248.3,0,342.5C366.7,461.1,304.5,484.6,242.5,484.6z"
}), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  id: "_x30_3_00000147198498490903515570000007600003699093435557_"
}, React.createElement("path", {
  fill: "#A6A49E",
  d: "M410.4,410.6c-92.8,92.7-243.1,92.7-335.9,0c-92.7-92.7-92.7-243.1,0-335.9c92.7-92.7,243.1-92.7,335.9,0 C503.2,167.5,503.2,317.8,410.4,410.6z"
})), React.createElement("g", {
  id: "_x30_3_00000057861756327488675330000011060017705603780241_"
}, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M413.6,243.4c0,95.8-77.7,173.5-173.5,173.5c-95.8,0-173.5-77.7-173.5-173.5 C66.7,147.6,144.3,70,240.1,70C335.9,70,413.6,147.6,413.6,243.4z"
})), React.createElement("g", {
  id: "_x30_3_00000122703628215090432260000013340640523297755314_"
}, React.createElement("path", {
  fill: "#A6A49E",
  d: "M240.1,411.1c-92.5,0-167.7-75.2-167.7-167.7c0-92.5,75.2-167.7,167.7-167.7S407.8,151,407.8,243.4 C407.8,335.9,332.6,411.1,240.1,411.1z M240.1,80.8c-89.7,0-162.7,73-162.7,162.7c0,89.7,73,162.7,162.7,162.7 s162.7-73,162.7-162.7C402.8,153.7,329.8,80.8,240.1,80.8z"
})))))), React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M114.1,62.3l5.4-3.7l29.8,18.9l-6.1,4.2l-6.5-4.3l-11.2,7.8l1.7,7.6l-6,4.1L114.1,62.3z M131.1,73.7l-9.5-6.2 l2.4,11L131.1,73.7z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M139.5,46.5l11.5-5.1c9.3-4.1,18.5-0.6,22.2,7.7l0,0.1c3.7,8.3,0.2,17.6-9.1,21.7l-11.5,5.1L139.5,46.5z  M148.6,49.4l7.9,17.8l5-2.2c5.3-2.4,7.3-7.5,5-12.8l0-0.1c-2.3-5.2-7.5-7.3-12.8-4.9L148.6,49.4z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M172,32.4l7.6-1.9l13.8,19.9l2.6-24.1l7.4-1.9l-4.6,34.7l-6.1,1.6L172,32.4z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M218.6,22.6l6.5-0.6l16.8,31.1l-7.4,0.7l-3.6-6.9l-13.6,1.3l-2.3,7.5l-7.2,0.7L218.6,22.6z M227.7,40.8 l-5.2-10l-3.3,10.8L227.7,40.8z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M248.4,21.2l6.5,0.6l13.3,21.1l1.8-19.8l7,0.6L274,55.9l-6-0.5l-13.7-21.8l-1.9,20.4l-7-0.6L248.4,21.2z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M283.2,41.3L283.2,41.3c2.5-8.9,11.1-14.3,20.7-11.7c5.9,1.6,8.8,4.6,10.9,8.2l-5.7,3.8 c-1.8-2.8-3.9-4.9-7-5.7c-5.2-1.5-10.2,1.9-11.7,7.2l0,0.1c-1.5,5.3,1,10.8,6.3,12.3c3.6,1,6.1,0.2,9.2-1.4l3.1,5.6 c-4.1,2.5-8.3,3.7-14.3,2C285.6,59.2,280.7,50.3,283.2,41.3z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M325.3,37.3l22,10.3l-2.7,5.7L329,46l-2.8,5.9l13.8,6.4l-2.7,5.7l-13.8-6.4l-2.9,6.1l15.9,7.4l-2.7,5.7 l-22.3-10.4L325.3,37.3z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M356.7,52.9l10.3,7.2c8.3,5.8,10.1,15.5,4.9,23l-0.1,0.1c-5.2,7.5-15,9.3-23.3,3.5l-10.3-7.2L356.7,52.9z  M358.9,62.2l-11.1,16l4.5,3.1c4.8,3.3,10.2,2.3,13.5-2.4l0.1-0.1c3.3-4.7,2.3-10.2-2.4-13.5L358.9,62.2z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#A6A49E",
  d: "M104.1,247.9v-0.2c0-18.8,14.4-33.5,33.9-33.5c13.2,0,21.6,5.5,27.4,13.4L151.9,238 c-3.7-4.5-7.9-7.6-14.1-7.6c-9,0-15.4,7.7-15.4,17.1v0.2c0,9.7,6.4,17.2,15.4,17.2c6.7,0,10.7-3.1,14.6-7.8l13.4,9.6 c-6.1,8.4-14.3,14.6-28.5,14.6C118.9,281.2,104.1,267.2,104.1,247.9L104.1,247.9z"
}), React.createElement("polygon", {
  fill: "#A6A49E",
  points: "171,215.3 189.3,215.3 189.3,239.6 212.5,239.6 212.5,215.3 230.4,215.3 230.4,280.2 212.5,280.2 212.5,255.5 188.9,255.5 188.9,280.2 171,280.2 171,215.3  "
}), React.createElement("polygon", {
  fill: "#A6A49E",
  points: "171,215.3 189.3,215.3 189.3,239.6 212.5,239.6 212.5,215.3 230.4,215.3 230.4,280.2 212.5,280.2 212.5,255.5 188.9,255.5 188.9,280.2 171,280.2 171,215.3  "
}), React.createElement("path", {
  fill: "#A6A49E",
  d: "M308.1,270.6l9.9-11.9c6.4,5.1,13.4,7.7,20.9,7.7c4.9,0,7.4-1.7,7.4-4.4v-0.3c0-2.8-2.1-4.2-11-6.3 c-13.8-3.1-24.4-7-24.4-20.3v-0.4c0-11.9,9.4-20.5,24.8-20.5c10.9,0,19.4,2.9,26.3,8.5l-8.9,12.5c-5.9-4.2-12.3-6.3-17.9-6.3 c-4.3,0-6.4,1.7-6.4,4.1v0.3c0,3,2.2,4.3,11.3,6.3c14.9,3.2,24.1,8.1,24.1,20.2v0.3c0,13.1-10.4,21-26,21 C326.8,281.2,316.1,277.6,308.1,270.6L308.1,270.6z"
}), React.createElement("path", {
  fill: "#A6A49E",
  d: "M359.9,236.2L359.9,236.2c0-4.5,3.6-8.3,8.2-8.3c4.6,0,8.2,3.7,8.2,8.2v0c0,4.5-3.6,8.2-8.2,8.2 C363.4,244.3,359.9,240.6,359.9,236.2L359.9,236.2z M374.2,236.1L374.2,236.1c0-3.4-2.6-6.3-6.2-6.3c-3.5,0-6.2,2.8-6.2,6.3v0 c0,3.4,2.6,6.2,6.2,6.2C371.5,242.4,374.2,239.5,374.2,236.1L374.2,236.1z M364.6,232h3.7c2,0,3.4,0.9,3.4,2.6 c0,1.2-0.6,2-1.6,2.4l1.8,2.6h-3l-1.4-2H367v2h-2.4V232L364.6,232z M368.2,235.6c0.7,0,1-0.3,1-0.8c0-0.5-0.4-0.8-1-0.8H367v1.6 H368.2L368.2,235.6z"
}), React.createElement("path", {
  fill: "#A6A49E",
  d: "M234.9,280.2h19l4.6-11.6h24.8l4.6,11.6h19.5L280,215.3h-17.7L234.9,280.2L234.9,280.2z M278.3,254.3h-14.6 l7.3-18.4L278.3,254.3L278.3,254.3z"
})));

var SvgChasAdvanced = function SvgChasAdvanced(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "CHAS_Advanced",
    x: "0px",
    y: "0px",
    viewBox: "0 0 485 485.3",
    style: {
      enableBackground: "new 0 0 485 485.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChasAdvanced, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CHAS Advanced.aa0266b4.svg";
export { ForwardRef as ReactComponent };